window.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;

    const commonSwiperAll = document.querySelectorAll('.js-vdListSwp');

    commonSwiperAll.forEach(function (swiperEl) {
        if (swiperEl.dataset.cSwiperInitialized === '1') return;
        swiperEl.dataset.cSwiperInitialized = '1';

        const id = swiperEl.id.replace('js-vdListSwp--', '');
        const nextEl = document.getElementById(`js-vdListSwp__nextEl--${id}`);
        const prevEl = document.getElementById(`js-vdListSwp__prevEl--${id}`);
        const scrollbarEl = document.getElementById(`js-vdListSwp__scrollbar--${id}`);

        new Swiper(swiperEl, {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 12,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
                sensitivity: 3
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            breakpoints: {
                750: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 25
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 25
                }
            },
            on: {
                init() {
                    this.el.classList.add('is-ready');
                }
            }
        });
    });
});